// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__aGwBI","right":"Footer_right__3d8HC","buttons":"Footer_buttons__2r1gt"};